<template>
  <div class="container">
    <div class="header box">
      <div class="info-item"><span class="title">快递状态</span><span class="status">{{ expressInfo.status }}</span></div>
      <div class="info-item"><span class="title">快递公司</span>{{ expressInfo.company }}</div>
      <div class="info-item"><span class="title">快递单号</span>{{ expressInfo.expressNo }}</div>
      <div class="call">
        <img src="~@assets/images/activity/lottery/kuaidi_icon_phone@2x.png" alt="">
        打电话
      </div>
      <div class="copy">复制</div>
    </div>
    <div class="logistics-info box">
      <van-steps :active="active" active-color="#37A1FF" direction="vertical">
        <van-step v-for="info in logisticsInfos" :key="info.time">
          <h3>{{ info.status }}</h3>
          <p class="time">{{ info.time }}</p>
          <p>{{ info.details }}</p>
        </van-step>
      </van-steps>
    </div>
    <div class="client-info box">
      <div class="info-item"><span class="title">收货人</span>{{ clientInfo.name }}</div>
      <div class="info-item"><span class="title">手机号码</span>{{ clientInfo.phone }}</div>
      <div class="info-item"><span class="title">收件地址</span>{{ clientInfo.address }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'logistics',
  data () {
    return {
      expressInfo: {
        status: '运输中',
        company: '中通快递',
        expressNo: 21456545124523
      },
      active: 0,
      logisticsInfos: [
        {
          status: '已签收',
          time: '14:00',
          details: '您的快件已签收'
        },
        {
          status: '派送中',
          time: '14:00',
          details: '您的快件交给张三，正在派送途中（联系电话：15832468798）'
        },
        {
          status: '运送中',
          time: '2022-08-31 09:23',
          details: '快件到达【苏州相城高铁新城营业点】'
        },
        {
          status: '已揽收',
          time: '2022-08-30 17:23',
          details: '中通快递已收取快件'
        }
      ],
      clientInfo: {
        name: '张三',
        phone: '136****4578',
        address: '苏州市相城区太阳路2266号'
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 351px;
  height: 690px;
  padding-top: 12px;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  color: #333;
}

.box {
  padding: 12px;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 8px;
  box-shadow: 0px 5px 15px 1px rgba(0, 0, 0, 0.051);
}

.header {
  position: relative;
  height: 103px;
}

.header .status {
  color: #096CEF;
}

.header .call {
  display: flex;
  align-items: center;
  position: absolute;
  top: 13px;
  right: 12px;
}

.call img {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.info-item {
  margin-bottom: 9px;
}

.copy {
  position: absolute;
  top: 71px;
  right: 14px;
}

.title {
  display: inline-block;
  width: 56px;
  margin-right: 4px;
  color: #999;
}

.logistics-info {
  height: 398px;
  background-color: #fff;
}

.logistics-info .time {
  margin: 4px 0 2px;
}

.client-info {
  height: 103px;
}
</style>
